import React from 'react';
import { Link } from 'react-router-dom';
import * as ActionTypes from '../../constants/LicensesTableActionTypes';

/**
 * @typedef {object} LicensesTableActionButtonsProps
 * @property {number} [orgId]
 * @property {string} [orgName]
 * @property {Object} [userData]
 * @property {boolean} [isFree]
 * @property {number} [pageMode]
 * @property {(userId: number) => void} [openConfirmDialog]
 */

/**
 * @param {LicensesTableActionButtonsProps} props
 */
const LicensesTableActionButtons = props => {
  const { pageMode, orgId, orgName, userData, openConfirmDialog, isFree = false } = props;

  const getLinkByActionType = () => {
    const userId = userData.key;
    switch (userData.Actions) {
      case ActionTypes.REMOVE:
        return (
          <a
            onClick={() => {
              openConfirmDialog(userId);
            }}>
            Remove
          </a>
        );
      case ActionTypes.ASSIGN:
        return (
          <Link
            to='/user-management/assign-license'
            state={{
              pageMode: pageMode,
              orgId: orgId,
              orgName: orgName,
              userIdForEditing: userId,
              orgUnitId: userData.LicensedOrgUnitId,
              isFree: isFree
            }}>
            Assign
          </Link>
        );
      case ActionTypes.EDIT:
        return (
          <Link
            to='/user-management/edit-license'
            state={{
              pageMode,
              orgId,
              orgName,
              isFree: userData.IsFree,
              userId,
              orgUnitId: userData.LicensedOrgUnitId,
              isDeactivated: userData.IsDeactivated
            }}>
            Edit
          </Link>
        );
      case ActionTypes.VIEW:
        return (
          <Link
            to={`/user-management/${orgId}/appraiser-profile/${userId}`}
            state={{
              pageMode,
              orgId,
              orgName,
              isFree: userData.IsFree,
              userId,
              orgUnitId: userData.LicensedOrgUnitId,
              isDeactivated: userData.IsDeactivated
            }}>
            View
          </Link>
        );
      default:
        return '';
    }
  };

  return getLinkByActionType();
};

export default LicensesTableActionButtons;
